import { Component, OnInit, Input, SimpleChanges, OnChanges, DoCheck } from '@angular/core';
import * as actions from '../../core/actions/expertise.actions';
import { Store } from '@ngrx/store';
import { ExpertiseService } from '../../shared/services/expertise.service';
import { Expertise } from '../../shared/models/expertise';

@Component({
  	selector: 'app-expertise-comptabilite',
  	templateUrl: './expertise-comptabilite.component.html',
  	styleUrls: ['./expertise-comptabilite.component.scss']
})
export class ExpertiseComptabiliteComponent implements OnInit, OnChanges, DoCheck  {

	@Input() expertise: Expertise;
	@Input() prestations: any[];

	userTot: any[] = [];
	totalAchat: any[] = [];

	constructor(
		private store: Store<any>, 
		private expertiseService: ExpertiseService
	) { }

  	ngOnInit() {  		
  	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.expertise && this.expertise.id) {
			this.expertiseService.userTotals(this.expertise.id).subscribe(t => this.userTot = t);			
			this.expertiseService.totalAchat(this.expertise.id).subscribe(t => this.totalAchat = t);			
		}
	}

	ngDoCheck() {
	}

	totalUser() {
		if (!this.userTot || this.userTot.length === 0) 
			return 0;
		return this.userTot.map(ut => parseFloat(ut.total)).reduce((p,c) => p+ c);
	}

	sumAchat() {
		if (!this.totalAchat || this.totalAchat.length === 0) 
			return 0;
		return this.totalAchat.map(ut => parseFloat(ut.total)).reduce((p,c) => p+ c);
	}	

	capitalisation() {
		
		return this.totalUser() - this.sumAchat();
	}	
}
